<template>
  <div>
    <div v-if="profileData">
      <div>
        <div class="edit-cont">
          <div class="edit-text">For editing your DoveMed profile, please visit your profile.</div>
          <!-- <div class="edit-text">Edit additional information on your DoveMed hospital’s profile.</div> -->
          <button class="profile-btn" @click="link">Visit Profile</button>
        </div>
        <div>
          <div v-if="profileData.about && profileData.about.length > 0" class="about-cont">
            <div class="header">About the hospital</div>
            <div class="bio">{{ profileData["about"] }}</div>
          </div>

          <div class="pad" v-if="profileData.ext_ref_id" :style="{ 'margin-bottom': '80px' }">
            <DoctorAboutReview :refId="profileData.ext_ref_id" :IsOwnerView="true" :avgRating="parseFloat(profileData.overall_rating || '0')" />
          </div>

          <div class="pad" v-if="profileData.ext_ref_id" :style="{ 'margin-bottom': '80px' }">
            <DoctorAboutRecommend :refId="profileData.ext_ref_id" :IsOwnerView="true" />
          </div>

          <div v-if="profileData.clinical_services && profileData.clinical_services.length > 0" class="about-cont">
            <div class="header">Clinical Services ({{ profileData.clinical_services[0].length }})</div>
            <div v-for="(service, ind) in profileData.clinical_services[0]" :key="ind" class="service-card-cont">
              <div class="service-header">
                <a-avatar
                  class="avatar-abt"
                  :style="{
                    display: 'flex',
                    'align-items': 'center',
                    'justify-content': 'center',
                    background: '#F1F5F9',
                    padding: '15px',
                  }"
                  :size="70"
                  :src="service.image"
                >
                </a-avatar>
                <!-- <img :src="service.image" /> -->
                <div class="sub-header">{{ service.clinicalservicebranch }}</div>
              </div>
              <div class="service-details">
                <ul>
                  <li class="services" v-for="(item, y) in service.sub_branches" :key="y">
                    {{ item.clinicalservicesubbranch }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="profileData.conditions && profileData.conditions.length > 0" class="about-cont">
            <div class="header">Conditions Treated ({{ profileData.conditions.length }})</div>
            <div :class="profileData.conditions.length > 4 ? 'service-details-8' : 'service-details-4'">
              <div class="list-cont" v-for="(item, y) in profileData.conditions" :key="y">
                <img :src="dot" />
                <span>{{ item.condition }}</span>
              </div>
            </div>
          </div>

          <div v-if="profileData.procedures && profileData.procedures.length > 0" class="about-cont">
            <div class="header">Procedures Performed ({{ profileData.procedures.length }})</div>
            <div :class="profileData.procedures.length > 4 ? 'service-details-8' : 'service-details-4'">
              <div class="list-cont" v-for="(item, y) in profileData['procedures']" :key="y">
                <img :src="dot" />
                <span>{{ item.procedure }}</span>
              </div>
            </div>
          </div>

          <div v-if="profileData.affiliated_hospitals && profileData.affiliated_hospitals.length > 0" class="about-cont">
            <div class="header">Affiliated Hospitals ({{ profileData.affiliated_hospitals.length }})</div>
            <div class="w-100" v-for="(card, index) in profileData.affiliated_hospitals" :key="index">
              <AffiliatedCard :item="card.hospital_profile_info" :type="'hospital'" :info="card" />
            </div>
          </div>

          <div v-if="profileData.affiliated_clinics && profileData.affiliated_clinics.length > 0" class="about-cont">
            <div class="header">Affiliated Clinics ({{ profileData.affiliated_clinics.length }})</div>
            <div class="w-100" v-for="(card, index) in profileData.affiliated_clinics" :key="index">
              <AffiliatedCard :item="card.clinic_profile_info" :type="'clinic'" :info="card" />
            </div>
          </div>
          
          <div v-if="profileData.affiliated_ohcps && profileData.affiliated_ohcps.length > 0" class="about-cont">
            <div class="header">Affiliated Advanced Medical Professionals ({{ profileData.affiliated_ohcps.length }})</div>
            <div class="w-100" v-for="(card, index) in profileData.affiliated_ohcps" :key="index">
              <AffiliatedCard :item="card.ohcp_info" :type="'hcp'" :info="card" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mtop">
          <div class="dovemed-card">
            <div style="{display: flex; justify-content: space-between}">
              <p class="title">General Information</p>
            </div>
            <p v-if="!cardKeys.about">
              {{ profileData.about }}
            </p>
            <p class="title">MISSION STATEMENT</p>
            <p v-if="profileData.hospital_info.mission_statement">
              <i> "{{ profileData.hospital_info.mission_statement }}"</i>
            </p>
            <a-textarea
              v-model="profileData['about']"
              :rows="4"
              v-if="cardKeys.about"
              class="editable-textarea"
            />
            <button
              class="dovemed-button primary-border font-primary ml-4"
              v-if="cardKeys.about"
              @click="save('about')"
            >
              Save
            </button>
            <button
              class="dovemed-button primary-border font-primary ml-4"
              v-if="cardKeys.about"
              @click="cancelEditable('about')"
            >
              Cancel
            </button>
          </div>
          <div class="dovemed-card ">
            <p class="title">
              {{ "clinical_services" | humanize }}
              {{ profileData["clinical_services"] | total }}
            </p>
            <div
              class="service-card d-flex "
              v-for="(service, ind) in profileData['clinical_services']"
              :key="ind"
            >
              <div
                class=" d-flex "
                v-for="(serv, index) in service"
                :key="index"
              >
                <div class="img">
                  <img :src="serv.image" />
                  <p class="title">{{ serv.clinicalservicebranch }}</p>
                </div>
                <div class="list">
                  <ul>
                    <li v-for="(item, y) in serv.sub_branches" :key="y">
                      {{ item.clinicalservicesubbranch }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="dovemed-card">
            <p class="title">
              {{ "conditions" | humanize }}
              {{ profileData["conditions"] | total }}
            </p>
            <div class="mt-4">
              <ul>
                <li v-for="(item, y) in profileData['conditions']" :key="y">
                  {{ item.condition }}
                </li>
              </ul>
            </div>
          </div>
          <div class="dovemed-card">
            <p class="title">
              {{ "procedures" | humanize }}
              {{ profileData["procedures"] | total }}
            </p>
            <div class="mt-4">
              <ul>
                <li v-for="(item, y) in profileData['procedures']" :key="y">
                  {{ item.procedure }}
                </li>
              </ul>
            </div>
          </div>
          <div class="dovemed-card">
            <p class="title">
              {{ "affiliated_physicians" | humanize }}
              {{ profileData["affiliated_physicians"] | total }}
            </p>
            <div
              v-for="(card, index) in profileData['affiliated_physicians']"
              :key="index"
            >
              <ProviderCard
                :id="card.physician_profile"
                :info="card.physician_profile_info"
                type="doctor"
                :isSelf="false"
              />
            </div>
          </div>
          <div class="dovemed-card">
            <p class="title">
              {{ "affiliated_hospitals" | humanize }}
              {{ profileData["affiliated_hospitals"] | total }}
            </p>
            <div
              v-for="(card, index) in profileData['affiliated_hospitals']"
              :key="index"
            >
              <ProviderCard
                :id="card.hospital_profile"
                :info="card.hospital_profile_info"
                type="hospital"
                :isSelf="false"
              />
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import ProviderCard from "../../home/provider/ProviderCard"
import DoctorAboutRecommend from "./view/DoctorAboutRecommend.vue"
import DoctorAboutReview from "./view/DoctorAboutReview.vue"
import AffiliatedCard from "../../home/provider/AffiliatedCard.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ViewHospitalAbout",
  data() {
    return {
      dot: require("../../../assets/dot.svg"),
      cardKeys: null,
      profileData: null,
      toDeleteKeys: [
        "id",
        "created_at",
        "updated_at",
        "is_deleted",
        "user",
        "is_verified",
        "npi_number",
        "state_licence",
        "licence_number",
        "display_name",
        "rec_description",
        "rec_option",
        "rec_user",
        "rec_user_circle",
        "recommendations",
        "user_circle",
        "ext_ref_id",
        "is_virtual",
        "hospital_type",
        "hospital_name",
        "phone_number",
        "address",
        "image",
        "subcircles",
        "overall_rating",
        "rating",
        "adult_specialities",
        "child_specialities",
      ],
      // test: null
      status: false,
    }
  },
  components: {
    ProviderCard,
    DoctorAboutRecommend,
    DoctorAboutReview,
    AffiliatedCard,
  },
  created() {
    console.warn("hospitalAbout.vue created")
    this.fetchData()
  },

  methods: {
    /**
     * Fetch user profile data
     */
    async fetchData() {
      if (this.authUser.user.ext_ref_id === this.authUser.user.id) {
        const data = await UserRepository.getOtherEntityProfile(
          {
            id: this.$route.params.id,
            role: "hospital",
          },
          this.currentCircle.id
        )
        this.profileData = data.data.data ? data.data.data : {}
        let profileDataCopy = { ...this.profileData }
        this.toDeleteKeys.forEach(key => {
          delete profileDataCopy[key]
        })
        // const keys = Object.keys(profileDataCopy)
        const keys = Object.keys(profileDataCopy)
        this.cardKeys = this.makeKeys(keys)
        this.status = true
      } else {
        const data = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
        this.profileData = data.data.data ? data.data.data[0] : {}
      }
      console.log("profileData:", this.profileData)
    },

    link() {
      if (this.authUser.user.display_name) {
        window.open(`${process.env.SSO_BASE_URL}/ratings/hospital/${this.authUser.user.ext_ref_id}-${this.authUser.user.display_name.split(" ").join("-")}`, "_blank")
      } else {
        window.open(`${process.env.SSO_BASE_URL}/ratings/hospital/${this.viewUser.ext_ref_id}-${this.viewUser.hospital_info.hospital_name.split(" ").join("-")}`, "_blank")
      }
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },
  },

  filters: {
    humanize: function (value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function (value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<!-- <style lang="scss" scoped>
.mtop {
  @media screen and (max-width:700px) {
    margin-top: 48px;
  }
}

.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  ul {
    list-style: none;
    /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    margin-left: 20px;
  }

  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;

    img {
      width: 2em;
    }

    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}

.service-card {
  border: 1px solid #e6e9ed;
  margin-bottom: 10px;

  .img {
    padding: 20px 15px;
    border-right: 1px solid #e6e9ed;

    img {
      height: 73px;
      width: 73px;
    }

    .title {
      margin: 0;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
      text-align: center;
    }
  }

  .list {
    padding: 20px 15px;
  }
}

ul>li {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 8px;

  &::before {
    color: #0c74bd;
  }
}

.banner {
  // min-height: 300px;
  // max-height: 400px;
  height: 400px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-top: -45px;
}

.doc-info {
  .doc-name {
    font-size: 24px;
    font-weight: bolder;
    white-space: nowrap;
  }

  .doc-loc text-truncate,
  .recommendations {
    font-size: 16px;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  text-align: right;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}

.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}

.profile-bg {
  .camera-btn {
    position: absolute;
    bottom: -9%;
    right: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.full-screen-camera {
  @media screen and (max-width: 800px) {
    display: none;
  }
}

@media screen and (max-width: 581px) {
  .doc-info .doc-name {
    font-size: 16px;
  }
}</style> -->

<style lang="scss" scoped>
.service-details-4 {
  width: 100%;
  display: grid;
  grid-template-columns: auto;
  row-gap: 16px;

  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // padding: 0px 24px;
    width: 100%;
    flex-wrap: wrap;
  }
}

.service-details-8 {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  row-gap: 16px;

  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // padding: 0px 24px;
    width: 100%;
    flex-wrap: wrap;
  }
}

.list-cont {
  display: flex;
  gap: 8px;
}

.pad {
  padding: 24px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.dailog1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: 100%;
}

.services::marker {
  color: #2a71d4;
  font-size: 150%;
}

.services {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.service-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  // padding: 0px 24px;
  width: 100%;
}

.service-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
}

.service-card-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 16px;
  gap: 16px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.bio {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  text-align: justify;
}

.header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  width: 100%;
}

.sub-header {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 42px;
  color: #0f1734;
}

.edit-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f !important;
  text-align: center;
}

.edit-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 16px;
  background: #f1f5f9;
  margin-bottom: 80px;
}

.about-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  margin-bottom: 80px;

  @media screen and (max-width: 900px) {
    padding: 0px;
  }
}

.profile-btn {
  padding: 8px 16px;
  background: #062b54;
  border-radius: 6px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  img {
    border-radius: 0.5em;
    max-width: 150px;
    max-height: 150px;
  }

  .title {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #0f1734;
  }

  ul {
    list-style: none;
    /* Remove default bullets */
  }

  ul li::before {
    content: "\2022";
    font-weight: bold;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: -1em;
  }

  .language {
    margin-left: 20px;
  }

  .mono-language {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin: 1em 0;

    img {
      width: 2em;
    }

    p {
      margin-left: 1em;
      margin-bottom: 0;
    }
  }
}

.service-card {
  border: 1px solid #e6e9ed;

  .img {
    padding: 20px 15px;
    border-right: 1px solid #e6e9ed;

    img {
      height: 73px;
      width: 73px;
    }

    .title {
      margin: 0;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
      text-align: center;
    }
  }

  .list {
    padding: 20px 15px;
  }
}

ul > li {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 8px;

  &::before {
    color: #0c74bd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/hospitalAbout.vue